/**
 * Base URL of the REST API.
 *
 * Development uses the dev-server proxy. Otherwise the runtime configuration
 * (window.__APP_CONFIG__.apiUrl, written at container start, see
 * docker/dokku/40-runtime-config.sh) wins over the value inlined at build
 * time (VUE_APP_API_URL).
 */
export function resolveApiBaseUrl({nodeEnv, buildApiUrl, runtimeConfig}) {
    if (nodeEnv === "development") {
        return "/api";
    }

    const runtimeApiUrl = runtimeConfig && runtimeConfig.apiUrl;

    return runtimeApiUrl || buildApiUrl;
}
